module.exports = __webpack_public_path__ + "img/RedBullMobileLogo.bc31b571.svg";